import "./AdvisoryServices.module.css";
import { useEffect } from "react";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OnzeExpertise from "./sections/OnzeExpertise";
import IndustryKnowledgeFaq from "./sections/IndustryKnowledgeFaq";
import Footer from "@/reusable_sections/Footer";
export default function AdvisoryServicesPage() {
  useEffect(() => {
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Expert sell-side M&A advisory, capital raises, and strategic advisory for businesses with $3M–$30M EBITDA. Affiliated with GT Securities, Member FINRA/SIPC.");
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = "Expert sell-side M&A advisory, capital raises, and strategic advisory for businesses with $3M–$30M EBITDA. Affiliated with GT Securities, Member FINRA/SIPC.";
      document.head.appendChild(meta);
    }
  }, []);
  return <div>
      <Header />
      <h1 className="sr-only">M&A Advisory, Capital Raises & Strategic Advisory Services</h1>
      <Hero />
      <OnzeExpertise />
      <IndustryKnowledgeFaq />
      <Footer />
    </div>;
}